import { render, staticRenderFns } from "./PrincipesFondateurs.vue?vue&type=template&id=1c09b6ea"
import script from "./PrincipesFondateurs.vue?vue&type=script&lang=js"
export * from "./PrincipesFondateurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports